var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { apiCreateClientRfpMessageLog } from '@/actions/ClientRfpNegotiateActions';
/**
 * 既読データの管理, 更新
 */
export const useRfpClientOneNegotiateMessageLog = (args) => {
    const { id, negotiateList, negotiateOne } = args;
    // 更新された既読カウント
    const [updatedReadCount, setUpdatedReadCount] = useState({});
    const dispatch = useDispatch();
    /**
     * メッセージ閲覧ログ更新
     */
    const updateRead = useCallback((updateReadArgs) => __awaiter(void 0, void 0, void 0, function* () {
        const { messageId, viewRequestId } = updateReadArgs;
        const path = {
            id,
            rfpNegotiateMessageId: messageId,
            viewRequestId,
        };
        yield dispatch(apiCreateClientRfpMessageLog({ path }, {}));
    }), [id, dispatch]);
    /**
     * メッセージ閲覧ログ更新: 予算
     */
    const updateReadCountOfBudget = useCallback((updateReadArgs) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        const { budget_negotiate: budgetNegotiate } = negotiateOne;
        const { viewRequestId } = updateReadArgs;
        // 既に更新されてる場合
        if (((_a = updatedReadCount[viewRequestId]) === null || _a === void 0 ? void 0 : _a.budget) !== undefined) {
            return;
        }
        yield updateRead(updateReadArgs);
        // 既読カウント更新
        setUpdatedReadCount((prev) => (Object.assign(Object.assign({}, prev), { [viewRequestId]: Object.assign(Object.assign({}, prev[viewRequestId]), { budget: (budgetNegotiate === null || budgetNegotiate === void 0 ? void 0 : budgetNegotiate.unread_count) || 0 }) })));
    }), [negotiateOne, setUpdatedReadCount, updateRead, updatedReadCount]);
    /**
     * メッセージ閲覧ログ更新: PJ開始時期
     */
    const updateReadCountOfStartDate = useCallback((updateReadArgs) => __awaiter(void 0, void 0, void 0, function* () {
        var _b;
        const { start_date_negotiate: startDateNegotiate } = negotiateOne;
        const { viewRequestId } = updateReadArgs;
        // 既に更新されてる場合
        if (((_b = updatedReadCount[viewRequestId]) === null || _b === void 0 ? void 0 : _b.startDate) !== undefined) {
            return;
        }
        yield updateRead(updateReadArgs);
        // 既読カウント更新
        setUpdatedReadCount((prev) => (Object.assign(Object.assign({}, prev), { [viewRequestId]: Object.assign(Object.assign({}, prev[viewRequestId]), { startDate: (startDateNegotiate === null || startDateNegotiate === void 0 ? void 0 : startDateNegotiate.unread_count) || 0 }) })));
    }), [negotiateOne, setUpdatedReadCount, updateRead, updatedReadCount]);
    /**
     * メッセージ閲覧ログ更新: PJ終了期間
     */
    const updateReadCountOfEndDate = useCallback((updateReadArgs) => __awaiter(void 0, void 0, void 0, function* () {
        var _c;
        const { end_date_negotiate: endDateNegotiate } = negotiateOne;
        const { viewRequestId } = updateReadArgs;
        // 既に更新されてる場合
        if (((_c = updatedReadCount[viewRequestId]) === null || _c === void 0 ? void 0 : _c.endDate) !== undefined) {
            return;
        }
        yield updateRead(updateReadArgs);
        // 既読カウント更新
        setUpdatedReadCount((prev) => (Object.assign(Object.assign({}, prev), { [viewRequestId]: Object.assign(Object.assign({}, prev[viewRequestId]), { endDate: (endDateNegotiate === null || endDateNegotiate === void 0 ? void 0 : endDateNegotiate.unread_count) || 0 }) })));
    }), [negotiateOne, setUpdatedReadCount, updateRead, updatedReadCount]);
    /**
     * 既読カウント初期化
     */
    const resetUpdatedReadCount = useCallback(() => {
        setUpdatedReadCount({});
    }, [setUpdatedReadCount]);
    /**
     * 一覧の未読カウント, 全未読件数 取得
     */
    const { unreadCounts, unreadTotalCount } = useMemo(() => {
        const counts = negotiateList.reduce((prev, current) => {
            var _a, _b, _c;
            const updatedCountBudget = ((_a = updatedReadCount[current.id]) === null || _a === void 0 ? void 0 : _a.budget) || 0;
            const updatedCountStartDate = ((_b = updatedReadCount[current.id]) === null || _b === void 0 ? void 0 : _b.startDate) || 0;
            const updatedCountEndDate = ((_c = updatedReadCount[current.id]) === null || _c === void 0 ? void 0 : _c.endDate) || 0;
            const updatedCount = updatedCountBudget + updatedCountStartDate + updatedCountEndDate;
            return Object.assign(Object.assign({}, prev), { [current.id]: current.unread_negotiate_message_count - updatedCount });
        }, {});
        const total = Object.values(counts).reduce((sum, count) => sum + count, 0);
        return {
            unreadCounts: counts,
            unreadTotalCount: total,
        };
    }, [negotiateList, updatedReadCount]);
    return {
        resetUpdatedReadCount,
        unreadCounts,
        unreadTotalCount,
        updateReadCountOfBudget,
        updateReadCountOfEndDate,
        updateReadCountOfStartDate,
    };
};
